"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Segment = exports.default = void 0;
var segment_component_1 = require("./segment.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(segment_component_1).default; } });
Object.defineProperty(exports, "Segment", { enumerable: true, get: function () { return segment_component_1.Segment; } });
